module.exports = __webpack_public_path__ + "img/support.2a2256b8.svg";